import {
  ForbiddenCodeEnum,
  isAuthError,
  isForbiddenError,
} from '@/context/services/type';

/**
 * Reloads the page on 401/403 to inherit Rails redirect + flash message behavior.
 * Must NOT reload for FORBIDDEN_MIMIC_MODE — a mimic admin impersonating a General/Approver
 * user gets 403 + code:'FORBIDDEN_MIMIC_MODE' because AdminInvoiceReports uses
 * `pundit_policy_for :administrator, :observer` (stricter than invoice_reports which uses :applicant).
 * Reloading would wrongly redirect the admin out of the page.
 */
export const handleAdminInvoiceReportsAccessError = (
  statusCode?: number,
  code?: string
): void => {
  if (code === ForbiddenCodeEnum.FORBIDDEN_MIMIC_MODE) return;
  if (isForbiddenError(statusCode) || isAuthError(statusCode)) {
    location.reload();
  }
};
